import { useEffect, useState } from "react";
import { IPersonaCheckList } from "./PersonaCheckList";
import { IPlantillaVerificacion, IPlantillaVerificacionPersonaRequest } from "../../../Interfaces/IPlantillaVerificacion";
import { IPaginacionComponent } from "../../../Interfaces/filter";
import PlantillaVerificacionService from "../../../services/ListaVerificacion/PlantillaVerificacionService";

export const UsePersonaCheckList=(props:IPersonaCheckList)=>{
    const [loading,setLoading]=useState<boolean>(false)
    const [items,setItems]=useState<IPlantillaVerificacion[]>([])
    const [filter, setFilter] = useState<IPlantillaVerificacionPersonaRequest>({
        skip: 0,
        take: 50,
        personaId:props.personaId
    });
    useEffect(()=>{
        if(filter){
            getPlantillas()
        }
      },[filter])
    const inital:IPlantillaVerificacionPersonaRequest={
        skip: 0,
        take: 50,
        personaId:props.personaId
    }
    const onChangeTake=(take:number)=>{
        setFilter({...filter,take:take,skip:0})
    }
    const onSkip=(skip:number)=>{
        setFilter({...filter,skip:skip})
    }
    const handleResetUpdate = () => {
        setFilter(inital)
    };
    const [pagination,setPagination]=useState<IPaginacionComponent>({
        isLoading:loading,
        onChangeTake: onChangeTake,
        onChangeSkip: onSkip,
        totalPagesPagination: 10,
        skipPagination: filter.skip,
        takePagination:filter.take??0,
        isVisible:true,
        total: 0,
    })
    const getPlantillas=()=>{
        setLoading(true)
        PlantillaVerificacionService.GetPlantillaVerificacionByPersona(filter).then((res)=>{
            const pag:IPaginacionComponent={
                isLoading:loading,
                onChangeTake: onChangeTake,
                onChangeSkip: onSkip,
                totalPagesPagination: res.data.pages,
                skipPagination: filter.skip,
                takePagination:filter.take??0,
                isVisible:true,
                actualPage:res.data.page,
                total: res.data.total,
              }
              setPagination(pag)
            setLoading(false)
            setItems(res.data.items)
        }).catch((e:any)=>{
            setLoading(false)
        })
    }
    return {filter,setFilter,items,loading,pagination,handleResetUpdate}
}